import firebase from "firebase";
import React from "react";
import { auth, firestore } from "../firebase/config";
import { AuthContextType, EmailPasswordSignupData } from "../libs/Interfaces";
import { useApp } from "./AppContext";


const AuthContext = React.createContext<AuthContextType>({
    signUpEmail: (data: EmailPasswordSignupData) => Promise.resolve(console.log),
    loginWithEmail: (email: string, password: string, remember?: boolean) => Promise.resolve(console.log(email, password)),
    logout: () => Promise.resolve(console.log()),
    currentUser: null,
    resetPassword: (email: string) => Promise.resolve(console.log(email)),
});

export function useAuth() {
    return React.useContext(AuthContext);
}

export function AuthProvider({ children }: { children: any }) {

    const [currentUser, setCurrentUser] = React.useState<firebase.User | null>(null);
    const [loading, setLoading] = React.useState(true);
    const { loadingComponent, position } = useApp();

    async function signUpEmail(data: EmailPasswordSignupData) {
        let signup = await auth.createUserWithEmailAndPassword(data.email, data.password);
        if (signup.user) await signup.user.updateProfile({
            displayName: data.name,
        });
        return saveUserData(signup.user?.uid, {
            public: {
                id: signup.user?.uid,
                image: null,
                isArtist: data.isArtist,
                name: data.name,
                followersCount: 0,
                followingCount: 0,
                twitter: "",
                facebook: "",
                instagram: "",
                youtube: "",
                bio: "",
            },
            private: {
                email: data.email,
                mobileNumber: null,
                latitude: position ? position.latitude : null,
                longitude: position ? position.longitude : null,
            }
        });
    }

    function resetPassword(email: string) {
        return auth.sendPasswordResetEmail(email);
    };

    async function saveUserData(uid: string | undefined, data: any) {
        if (!uid) return;
        let task = async (alldata: any, id: string) => {
            await firestore.collection("users").doc(id).collection("public").doc("data").set(alldata.public);
            await firestore.collection("users").doc(id).collection("private").doc("data").set(alldata.private);
        }
        return await task(data, uid);
    };

    function loginWithEmail(email: string, password: string, remember?: boolean) {
        if (remember) auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        else auth.setPersistence(firebase.auth.Auth.Persistence.NONE);
        return auth.signInWithEmailAndPassword(email, password);
    }

    function logout() {
        return auth.signOut();
    }

    React.useEffect(() => {
        auth.setPersistence(firebase.auth.Auth.Persistence.SESSION);
        let unsubcscribe = auth.onAuthStateChanged(user => {
            setCurrentUser(user);
            setLoading(false);
        });
        //return removeEventListeners;
        return unsubcscribe;
    }, []);

    const value: AuthContextType = {
        currentUser: currentUser,
        logout: logout,
        resetPassword,
        signUpEmail: signUpEmail,
        loginWithEmail: loginWithEmail
    };

    return (
        <AuthContext.Provider value={value}>
            {loading ? loadingComponent : children}
        </AuthContext.Provider>
    );
}